
import _ from 'lodash';

export default {
  /**
   * 获取用户信息
   */
  getUserInfo(state) {
    console.log('获取用户信息')
    if (!_.size(state.userInfo)) {
      var userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      state.userInfo = userInfo;
      return userInfo;
    }
    return state.userInfo;
  },
  /**
   * 获取Toke信息
   */
  getToken(state) {
    if (_.isEmpty(state.token)) {
      var token = localStorage.getItem("token") || '';
      state.token = token;
      return token;
    }
    return state.token;
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js